import { render, staticRenderFns } from "./BaseTokenInput.vue?vue&type=template&id=6cb6fa4b"
import script from "./BaseTokenInput.vue?vue&type=script&lang=js"
export * from "./BaseTokenInput.vue?vue&type=script&lang=js"
import style0 from "./BaseTokenInput.vue?vue&type=style&index=0&id=6cb6fa4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports